// extracted by mini-css-extract-plugin
export default {"edit":"device_edit__VnZkZ","container":"device_container__JD3ym","version":"device_version__Mt1b8","input":"device_input__EF4Kx"};